// Visual "000 000 0000" grouping for the phone number field. The stored
// value (form.phone_number) always stays plain digits -- this only formats
// what's shown in the input.
export function formatPhoneDisplay(digits = "") {
  // The API can return phone_number as null (the default above only covers
  // undefined), so treat null/non-strings as empty instead of crashing.
  const truncated = typeof digits === "string" ? digits.slice(0, 10) : "";
  const groups = [truncated.slice(0, 3), truncated.slice(3, 6), truncated.slice(6, 10)];
  return groups.filter(Boolean).join(" ");
}
